import React, { useState } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';

export const ComponentCard = ({
  children,
  title,
  subtitle,
  dropdown = false,
  handleClick,
  name,
}) => {
  // Preparamos variables necesarias
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Función que alterna la apertura/cierre del dropdown
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <Card color="white">
      <CardTitle tag="h4" className="border-bottom px-4 py-3 mb-0">
        {dropdown === true ? (
          <Dropdown nav isOpen={dropdownOpen} toggle={toggle.bind(null)} className="list-unstyled">
            <DropdownToggle nav caret>
              {title}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={handleClick} href="/alumnos">
                Ir al listado
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        ) : (
          <>{title}</>
        )}
        {name ? <span className="float-end mb-0">{name}</span> : ''}
      </CardTitle>
      <CardBody className="p-4">
        <CardSubtitle className="text-muted mb-3">{subtitle || ''}</CardSubtitle>
        <div>{children}</div>
      </CardBody>
    </Card>
  );
};
